import { AdminApiError, request } from '../api/client.js'
import type {
  JobAttemptsResponse,
  JobDefinitionsResponse,
  ListJobAttemptsParams,
  ListJobDefinitionsParams,
} from './types.js'

const BASE = '/coach/admin/jobs'

function appendAttemptFilters(
  qs: URLSearchParams,
  params: ListJobDefinitionsParams,
): void {
  if (params.jobName) qs.set('job_name', params.jobName)
  if (params.status) qs.set('status', params.status)
  if (params.release) qs.set('release', params.release)
  if (params.since) qs.set('since', params.since)
  if (params.until) qs.set('until', params.until)
}

export const adminJobsApi = {
  definitions(params: ListJobDefinitionsParams = {}): Promise<JobDefinitionsResponse> {
    const qs = new URLSearchParams()
    appendAttemptFilters(qs, params)
    const suffix = qs.size > 0 ? `?${qs.toString()}` : ''
    return request<JobDefinitionsResponse>(`${BASE}/definitions${suffix}`, { method: 'GET' })
  },
  attempts(params: ListJobAttemptsParams = {}): Promise<JobAttemptsResponse> {
    const qs = new URLSearchParams()
    appendAttemptFilters(qs, params)
    if (params.sort) qs.set('sort', params.sort)
    if (params.limit !== undefined) qs.set('limit', String(params.limit))
    if (params.offset !== undefined) qs.set('offset', String(params.offset))
    const suffix = qs.size > 0 ? `?${qs.toString()}` : ''
    return request<JobAttemptsResponse>(`${BASE}/attempts${suffix}`, {
      method: 'GET',
    })
  },
}

export function messageForJobsError(error: unknown): string {
  if (error instanceof AdminApiError) {
    if (error.detail === 'admin_required') {
      return 'You do not have permission to investigate background jobs.'
    }
    return error.message
  }
  return error instanceof Error ? error.message : 'Request failed'
}
